// extracted by mini-css-extract-plugin
export var borderRadius = "_56-4";
export var large = "_56-3";
export var logoContainer = "_56-0";
export var nameLogo = "_56-2";
export var small = "_56-1";